import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { IconHolder, Icons, Tooltip } from '@usepepper/sprout-kit-ui';
import { Pressable, StyleSheet } from 'react-native';
import { PricingGroupBy } from '@sales-portal/domain/pricing/blocs/utils/pricing-grouping';

const SWITCH_TO_LABEL_KEY: Record<PricingGroupBy, string> = {
  [PricingGroupBy.Restaurant]: 'pricing.group_by.switch_to_item_view',
  [PricingGroupBy.VariantPack]: 'pricing.group_by.switch_to_account_view',
};

interface Props {
  groupBy: PricingGroupBy;
  onPress: () => void;
}

export const PricingGroupByToggleButton: React.FC<Props> = ({
  groupBy,
  onPress,
}) => {
  const [styles, theme] = useStyles();
  const label = i18n.t(SWITCH_TO_LABEL_KEY[groupBy]);

  return (
    <Tooltip offset={4} placement="bottom">
      <Tooltip.Trigger>
        <Pressable
          accessibilityLabel={label}
          accessibilityRole="button"
          onPress={onPress}
          style={({ pressed, hovered }) =>
            StyleSheet.flatten([
              styles.trigger,
              (pressed || hovered) && styles.triggerHovered,
            ])
          }
          testID="pricing-group-by-toggle"
        >
          <IconHolder color={theme.sk.color.icon.secondary} size="$sm">
            <Icons.ArrowLeftRight />
          </IconHolder>
        </Pressable>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Tooltip.Text>{label}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip>
  );
};

const useStyles = createStyles((theme) => ({
  trigger: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.button.secondary.default,
    borderRadius: theme.sk.radii.radiusMedium,
    height: theme.sk.spacing.space2xlarge,
    justifyContent: 'center',
    marginLeft: theme.sk.spacing.spaceSmall,
    width: theme.sk.spacing.space2xlarge,
  },
  triggerHovered: {
    backgroundColor: theme.sk.color.bg.button.secondary.hover,
  },
}));
